export function ErrorText(props: { text: string }) {
  return (
    <label className="label">
      <span className={"label-text-alt font-bold text-error"}>{props.text}</span>
    </label>
  )
}